import { useTranslation } from "react-i18next";
import CheckoutOverview from "../Checkout/Overview/CheckoutOverview";
import UserCartStore from "../UserData/_stores/UserCartStore";
import { useMemo } from "react";
import Immutable from "immutable";
import CheckoutShipping from "../Checkout/Shipping/CheckoutShipping";
import CheckoutPayment from "../Checkout/Payment/CheckoutPayment";
import { useParams } from "react-router";
import { useAppSelector } from "../Common/_hooks/useAppSelector";

export default function InvoicePagePayment() {
  const [tR] = useTranslation('routes')
  const params = useParams<{ invoiceId: string }>()

  const order = useAppSelector(state => params.invoiceId ? state.get('userData').get('orders').get('data').find(value => value.get('invoice_id') === params.invoiceId) : undefined)

  const orders = useMemo(() => {
    return order ? Immutable.OrderedMap({[order.get('id')]: order}) : Immutable.OrderedMap<string, UserCartStore>()
  }, [order])

  if(!order) return null

  return <CheckoutPayment
    orders={orders}
    confirmationUrl={tR('/invoice/{{invoice_id}}', {invoice_id: order.get('invoice_id')})}
  />
}